var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"shueiJinJiouFooter"},_vm._l((_vm.filterItemList),function(item){return _c('WaterGoldItem',{key:item.title,staticClass:"shueiJinJiouFooter__item",attrs:{"item":item}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }